import { useTranslation } from "@redotech/redo-i18n";
import { useCommandPalette } from "@redotech/redo-web/command-palette/contexts/command-palette-context";
import { memo, useEffect, useRef } from "react";

export const SearchResultsLanguageSync = memo(
  function SearchResultsLanguageSync() {
    const { t } = useTranslation();
    const { actions, state } = useCommandPalette();
    const { performSearch } = actions;
    const previousTRef = useRef(t);

    useEffect(() => {
      if (previousTRef.current === t) {
        return;
      }
      previousTRef.current = t;

      if (!state.searchValue.trim()) {
        return;
      }

      void performSearch(state.searchValue);
    }, [performSearch, state.searchValue, t]);

    return null;
  },
);
